import * as React from 'react';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import { Stack, Typography } from '@mui/material';

import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Service from '../../../util/Service';
import SearchField from '../../util/SearchField';

function not(a, b) {
    return a.filter((value) => !b.includes(value));
}

function intersection(a, b) {
    return a.filter((value) => b.includes(value));
}

export default function AcessoUserPage() {
    const [selectedIndex, setSelectedIndex] = React.useState(-1);
    const [allRegras, setAllRegras] = React.useState();
    const [allUser, setAllUser] = React.useState();
    const [allUserF, setAllUserF] = React.useState();
    const [user, setUser] = React.useState();
    const [checked, setChecked] = React.useState([]);
    const [left, setLeft] = React.useState([]);
    const [right, setRight] = React.useState([]);
    const [podeSalvar, setPodeSalvar] = React.useState(false)

    const leftChecked = intersection(checked, left);
    const rightChecked = intersection(checked, right);

    React.useEffect(() => {
        buscaTodosUser();
        buscaTodasRegras();
    }, [])
    React.useEffect(() => {
        if( allUser){
            setAllUserF(allUser);
        }
    }, [allUser])

    React.useEffect(() => {
        if( right && right.length > 0){            
            let arr = [...left];
            for(let x=0; x < right.length; x++){
                const nm = right[x].nome;
                const item = arr.find( l => l.nome === nm);
                if( item ){
                    let index = arr.indexOf(item);
                    arr.splice(index, 1);
                }
            }
            setLeft(arr);
        }
    }, [right])
    React.useEffect(() => {
        if( podeSalvar){
            let rr = [];
            for(let x in right){
                rr.push( right[x].nome);
            }
            let u = {
                id: user.id,
                rules: rr
            }; 
            Service.POST("/api/security/user/updateRegra", u).then( r =>{
                let arr = [...allUser];
                let item = arr.find( a => a.id === u.id);
                if( item ){
                    item.rules = rr;
                }
                setAllUser(arr);
                setPodeSalvar(false);
            }).catch( er =>{
                console.log( er)
            });
        }
    }, [podeSalvar])
    
    function buscaTodasRegras(){
        Service.GET("/api/acesso/findAll").then(r => {
            setAllRegras(r);
            setLeft( r );
        })
    }
    function buscaTodosUser() {
        Service.GET("/api/security/user/findAllComRules").then(r => setAllUser(r))
    }
    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };

    function salvaUserRule(){
        setPodeSalvar(true);
    }
    const handleAllRight = () => {
        setRight(right.concat(left));
        setLeft([]);

        salvaUserRule();
    };

    const handleCheckedRight = () => {
        setRight(right.concat(leftChecked));
        setLeft(not(left, leftChecked));
        setChecked(not(checked, leftChecked));
        salvaUserRule();
    };

    const handleCheckedLeft = () => {
        setLeft(left.concat(rightChecked));
        setRight(not(right, rightChecked));
        setChecked(not(checked, rightChecked));
        salvaUserRule();
    };

    const handleAllLeft = () => {
        setLeft(left.concat(right));
        setRight([]);
        salvaUserRule();
    };

    const customList = (items) => (
        <Paper sx={{ width: 320, height:400, overflow: 'auto' }}>
            <List dense component="div" role="list">
                {items.map((value) => {
                    const labelId = `transfer-list-item-${value}-label`;

                    return (
                        <ListItemButton
                            key={"id-"+value.nome}
                            role="listitem"
                            onClick={handleToggle(value)}
                        >
                            <ListItemIcon>
                                <Checkbox
                                    checked={checked.includes(value)}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                        'aria-labelledby': labelId,
                                    }}
                                />
                            </ListItemIcon>
                            <ListItemText 
                                id={labelId} 
                                primary={value.nome} 
                                secondary={value.descricao}
                            />
                        </ListItemButton>
                    );
                })}
            </List>
        </Paper>
    );
    function handleUserClick(row, index){
        setUser(row);
        setSelectedIndex(index);
        setLeft(allRegras);
        if( row){
            let arr = [];
            for(let x in row.rules){
                const nm = row.rules[x];
                const item = allRegras.find(r => r.nome === nm);
                if( item) arr.push(item);
                else arr.push({
                    nome: nm,
                    descricao:'??'
                })
            }
            setRight(arr);
        } 
    }

    function UserList() {
        return (
            <Paper sx={{ width: 320, height:400, overflow: 'auto' }}>
                <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                    {allUserF && allUserF.map((row, index) =>
                        <React.Fragment key={index}>
                            <ListItemButton 
                                alignItems="flex-start"
                                selected={selectedIndex === index}
                                onClick={() => handleUserClick(row, index)}
                            >
                                <ListItemAvatar>
                                    {row.foto && <Avatar alt={row.nome} src={row.foto} />}
                                    {!row.foto && <Avatar>{row.nome[0]}</Avatar>}
                                </ListItemAvatar>
                                <ListItemText
                                    primary={row.nome}
                                    secondary={
                                        <Typography
                                            component="span"
                                            variant="body2"
                                            sx={{ color: 'text.primary', display: 'inline' }}
                                        >
                                            Email: {" — " + row.email}
                                        </Typography>
                                    }
                                />
                            </ListItemButton>
                            <Divider variant="inset" component="li" />
                        </React.Fragment>
                    )}

                </List>
            </Paper>
        );
    }
    function onSearchRight(txt){
        alert('Não implementado')
    }
    function onSearchLeft(txt){
        alert('Não implementado')
    }
    function onSearch(txt){
        console.log( txt, allUser );
        let arr= []
        for(let x in allUser){
            const u = allUser[x];
            if( u.nome.indexOf(txt) >=0){
                arr.push(u);
                continue;
            }
            if( u.login.indexOf(txt) >=0){
                arr.push(u);
                continue;
            }
            if( u.email.indexOf(txt) >=0){
                arr.push(u);
                continue;
            }
            for(let xx in u.rules){
                const r = u.rules[xx];
                if( r.indexOf(txt) >=0){
                    arr.push(u);
                    break;
                }
            }
        }
        setAllUserF(arr);
        setSelectedIndex(-1);
    }

    return (
        <Grid
            container
            spacing={2}
            sx={{
                justifyContent: 'center',
                // alignItems: 'center' 
            }}
        >
            <Grid>
                <Stack spacing={2}>
                    <Typography align='center'>Operadores</Typography>
                    <SearchField handleSearch={onSearch} width={310} />
                    {UserList()}
                </Stack>
            </Grid>
            <Grid>
                <Stack spacing={2}>
                    <Typography align='center'>Regras do sistema</Typography>
                    <SearchField handleSearch={onSearchLeft} width={310} />
                    { left && customList(left)}
                </Stack>
            </Grid>
            <Grid>
                <Grid container direction="column" sx={{ alignItems: 'center', marginTop:20 }}>
                    <Button
                        sx={{ my: 0.5 }}
                        variant="outlined"
                        size="small"
                        onClick={handleAllRight}
                        disabled={left.length === 0}
                        aria-label="move all right"
                    >
                        ≫
                    </Button>
                    <Button
                        sx={{ my: 0.5 }}
                        variant="outlined"
                        size="small"
                        onClick={handleCheckedRight}
                        disabled={leftChecked.length === 0}
                        aria-label="move selected right"
                    >
                        &gt;
                    </Button>
                    <Button
                        sx={{ my: 0.5 }}
                        variant="outlined"
                        size="small"
                        onClick={handleCheckedLeft}
                        disabled={rightChecked.length === 0}
                        aria-label="move selected left"
                    >
                        &lt;
                    </Button>
                    <Button
                        sx={{ my: 0.5 }}
                        variant="outlined"
                        size="small"
                        onClick={handleAllLeft}
                        disabled={right.length === 0}
                        aria-label="move all left"
                    >
                        ≪
                    </Button>
                </Grid>
            </Grid>
            <Grid>
                <Stack spacing={2}>
                    <Typography align='center'>Regras { user?user.nome:'Usuário'} </Typography>
                    <SearchField handleSearch={onSearchRight} width={310} />
                    {right && customList(right)}
                </Stack>
            </Grid>
        </Grid>
    );
}
